import React, { useState } from 'react'
import PropTypes from 'prop-types'
import _, { find, isUndefined, remove } from 'lodash'
import { Button, Checkbox, Form, Modal, Table } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { getBarcodeProduct } from '../../../../modules/barcodeProduct'
import SearchBarcodeForm from '../SearchBarcodeForm'

const BrandProductForm = (props) => {
  const dispatch = useDispatch()
  const [options, setOptions] = useState({
    page: 0,
    size: 10,
    isBrand: true
  })
  const [barcodeIds, setBarcodeIds] = useState([])
  const { visible, onOk, onCancel, formData } = props

  const { barcodeProductObj } = useSelector(
    (state) => ({
      barcodeProductObj: state.barcodeProduct.barcodeProductObj
    }),
    []
  )

  async function onShowSizeChange(current, pageSize) {
    options.size = pageSize
    setOptions(options)
    await dispatch(getBarcodeProduct(options))
  }

  async function onChange(page) {
    options.page = page - 1
    setOptions(options)
    await dispatch(getBarcodeProduct(options))
  }

  async function onSelect(e, record) {
    const result = find(barcodeIds, (item) => {
      return item === record.id
    })

    if (!isUndefined(result)) {
      setBarcodeIds((prevState) => {
        remove(prevState, (item) => {
          return item === record.id
        })
        return [...prevState]
      })
    } else {
      setBarcodeIds((prevState) => {
        prevState.push(record.id)
        return [...prevState]
      })
    }
  }

  const columns = [
    {
      title: 'รูปภาพ',
      dataIndex: 'images',
      key: 'images',
      render: (text) => <img src={text} alt="" width={64} height={64} />
    },
    {
      title: 'Barcode',
      dataIndex: 'barcodeData',
      key: 'barcodeData'
    },
    {
      title: 'Brand',
      dataIndex: 'brand',
      key: 'brand'
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name'
    },
    {
      title: 'เลือก',
      key: 'select',
      render: (text, record) => (
        <Checkbox onChange={(e) => onSelect(e, record)} />
      )
    }
  ]

  return (
    <Modal
      width={1000}
      title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} New Product`}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={() => onCancel()}>
          Cancel
        </Button>,
        <Button key="ok" type="primary" onClick={() => onOk(barcodeIds)}>
          Add
        </Button>
      ]}>
      <SearchBarcodeForm />
      <Table
        bordered
        dataSource={barcodeProductObj.content}
        columns={columns}
        pagination={{
          current: barcodeProductObj.pageable.pageNumber + 1,
          pageSize: barcodeProductObj.size,
          pageSizeOptions: ['10', '20', '50', '100'],
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          onChange: onChange,
          total: barcodeProductObj.totalElements
        }}
      />
    </Modal>
  )
}

BrandProductForm.propTypes = {
  visible: PropTypes.bool.isRequired,
  formData: PropTypes.object.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

const WrappedBrandProductForm = Form.create({ name: 'BrandProductForm' })(
  BrandProductForm
)
export default WrappedBrandProductForm



// WEBPACK FOOTER //
// ./src/pages/Brand/BrandProduct/BrandProductForm/index.js